import { useQuery } from "react-query";
import {
  getManagerDashboard,
  getManagerTeam,
  getTeamMemberDetail,
  getManagerReports,
  getTeamMemberGrants,
  getTeamMemberGrantDetails,
  getTeamMemberVestingDetails,
} from "../api/managerPortal";

export function useManagerDashboard() {
  return useQuery({
    queryKey: "managerDashboard",
    queryFn: getManagerDashboard,
  });
}

export function useManagerTeam() {
  return useQuery({
    queryKey: "managerTeam",
    queryFn: getManagerTeam,
  });
}

export function useTeamMemberDetail(employeeId: string) {
  return useQuery({
    queryKey: ["teamMember", employeeId],
    queryFn: () => getTeamMemberDetail(employeeId),
    enabled: !!employeeId,
  });
}

export function useManagerReports() {
  return useQuery({
    queryKey: "managerReports",
    queryFn: getManagerReports,
  });
}

export function useTeamMemberGrants(employeeId: string) {
  return useQuery({
    queryKey: ["teamMemberGrants", employeeId],
    queryFn: () => getTeamMemberGrants(employeeId),
    enabled: !!employeeId,
  });
}

export function useTeamMemberGrantDetails(grantId: string) {
  return useQuery({
    queryKey: ["teamMemberGrantDetails", grantId],
    queryFn: () => getTeamMemberGrantDetails(grantId),
    enabled: !!grantId,
  });
}

export function useTeamMemberVestingDetails(employeeId: string) {
  return useQuery({
    queryKey: ["teamMemberVesting", employeeId],
    queryFn: () => getTeamMemberVestingDetails(employeeId),
    enabled: !!employeeId,
  });
}
